'use client'

import {
  ThemeProvider as NextThemesProvider,
  type ThemeProviderProps,
} from 'next-themes'

export default function ThemeProvider({
  children,
  scriptProps,
  ...props
}: ThemeProviderProps) {
  // next-themes 0.4.6의 bootstrap은 서버 HTML에서만 실행한다.
  // 클라이언트에서는 provider effect가 테마를 동기화하므로 실행 불가능한 script로 표시한다.
  // https://github.com/pacocoursey/next-themes/issues/385
  const bootstrapProps =
    typeof window === 'undefined'
      ? scriptProps
      : { ...scriptProps, type: 'text/plain' }

  return (
    <NextThemesProvider {...props} scriptProps={bootstrapProps}>
      {children}
    </NextThemesProvider>
  )
}
